'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _contentTypes = require('../constants/contentTypes');

var _Status = require('./Status');

var _Status2 = _interopRequireDefault(_Status);

var _messageDeleteStatus = require('../constants/messageDeleteStatus');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CommonMessage = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.COMMON_MESSAGE), _defineProperty(_Record, 'attachments', (0, _immutable.List)()), _defineProperty(_Record, 'clientType', null), _defineProperty(_Record, 'contentType', _contentTypes.SIMPLE), _defineProperty(_Record, 'hasMore', false), _defineProperty(_Record, 'id', null), _defineProperty(_Record, 'inReplyToId', null), _defineProperty(_Record, 'messageDeletedStatus', _messageDeleteStatus.NOT_DELETED), _defineProperty(_Record, 'richText', ''), _defineProperty(_Record, 'sender', (0, _immutable.Map)()), _defineProperty(_Record, 'status', (0, _Status2.default)()), _defineProperty(_Record, 'text', ''), _defineProperty(_Record, 'timestamp', null), _Record), 'CommonMessage');

exports.default = CommonMessage;
module.exports = exports['default'];